const storyType = ({ item, dictionary, type }) => {
  if (type === "podcast") return `Ep #${item.episode_number}`
  if (item.web_article_type) return item.web_article_type
  if (item.label) return item.label
  return dictionary.find(
    (dictionaryItem) => dictionaryItem.key.current === item.type
  )?.value
}

export default storyType
